import { render, staticRenderFns } from "./productsTab.vue?vue&type=template&id=325d402e&scoped=true"
import script from "./productsTab.vue?vue&type=script&lang=js"
export * from "./productsTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "325d402e",
  null
  
)

export default component.exports